import { render, staticRenderFns } from "./login-newRegister.vue?vue&type=template&id=ebe50ace&scoped=true&"
import script from "./login-newRegister.vue?vue&type=script&lang=js&"
export * from "./login-newRegister.vue?vue&type=script&lang=js&"
import style0 from "./login-newRegister.vue?vue&type=style&index=0&id=ebe50ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe50ace",
  null
  
)

export default component.exports